// Script melhorado para calculadora de frete com busca automática de CEP
document.addEventListener("DOMContentLoaded", function () {
  const shippingCalculators = document.querySelectorAll("shipping-calculator");

  shippingCalculators.forEach(function (calculator) {
    const countrySelect = calculator.querySelector(".js-country-select");
    const provinceSelect = calculator.querySelector(".js-province-select");
    const zipInput = calculator.querySelector(".js-zip-input");
    const loadingDiv = calculator.querySelector(".js-cep-loading");
    const calcButton = calculator.querySelector('button[type="button"]');

    if (countrySelect && zipInput && provinceSelect && calcButton) {
      // Define Brasil como padrão sempre
      countrySelect.value = "Brazil";

      // Dispara evento de mudança para carregar estados do Brasil
      const changeEvent = new Event("change", { bubbles: true });
      countrySelect.dispatchEvent(changeEvent);

      // Mapeamento de UF para nomes completos dos estados do Brasil
      const estadosBrasil = {
        AC: "Acre",
        AL: "Alagoas",
        AP: "Amapá",
        AM: "Amazonas",
        BA: "Bahia",
        CE: "Ceará",
        DF: "Distrito Federal",
        ES: "Espírito Santo",
        GO: "Goiás",
        MA: "Maranhão",
        MT: "Mato Grosso",
        MS: "Mato Grosso do Sul",
        MG: "Minas Gerais",
        PA: "Pará",
        PB: "Paraíba",
        PR: "Paraná",
        PE: "Pernambuco",
        PI: "Piauí",
        RJ: "Rio de Janeiro",
        RN: "Rio Grande do Norte",
        RS: "Rio Grande do Sul",
        RO: "Rondônia",
        RR: "Roraima",
        SC: "Santa Catarina",
        SP: "São Paulo",
        SE: "Sergipe",
        TO: "Tocantins",
      };

      // Função para formatar CEP brasileiro
      function formatCEP(value) {
        value = value.replace(/\D/g, "");
        if (value.length > 5) {
          value = value.slice(0, 5) + "-" + value.slice(5, 8);
        }
        return value;
      }

      // Função para buscar dados do CEP
      async function buscarCEP(cep) {
        try {
          // Remove formatação do CEP
          const cepLimpo = cep.replace(/\D/g, "");

          if (cepLimpo.length !== 8) {
            return null;
          }

          if (loadingDiv) {
            loadingDiv.style.display = "block";
          }

          // Usa a API do ViaCEP (gratuita e confiável)
          const response = await fetch(
            `https://viacep.com.br/ws/${cepLimpo}/json/`
          );
          const data = await response.json();

          if (loadingDiv) {
            loadingDiv.style.display = "none";
          }

          if (data.erro) {
            return null;
          }

          return {
            uf: data.uf,
            cidade: data.localidade,
            bairro: data.bairro,
            logradouro: data.logradouro,
          };
        } catch (error) {
          console.log("Erro ao buscar CEP:", error);
          if (loadingDiv) {
            loadingDiv.style.display = "none";
          }
          return null;
        }
      }

      // Função para selecionar o estado no select
      function selecionarEstado(uf) {
        const nomeEstado = estadosBrasil[uf];
        if (nomeEstado) {
          // Procura a opção pelo nome completo
          const options = provinceSelect.options;
          for (let i = 0; i < options.length; i++) {
            if (
              options[i].text === nomeEstado ||
              options[i].value === nomeEstado
            ) {
              provinceSelect.selectedIndex = i;
              break;
            }
          }
        }
      }

      // Função para mostrar loading no botão
      function setButtonLoading(loading) {
        const originalText =
          calcButton.getAttribute("data-original-text") ||
          calcButton.textContent;

        if (!calcButton.getAttribute("data-original-text")) {
          calcButton.setAttribute("data-original-text", originalText);
        }

        if (loading) {
          calcButton.disabled = true;
          calcButton.textContent = "Buscando localização...";
          calcButton.classList.add("is-loading");
        } else {
          calcButton.disabled = false;
          calcButton.textContent = originalText;
          calcButton.classList.remove("is-loading");
        }
      }

      // Função para mostrar erro no input
      function showInputError(input, show = true) {
        if (show) {
          input.classList.add("error");
          input.style.borderColor = "#ff4444";
        } else {
          input.classList.remove("error");
          input.style.borderColor = "";
        }
      }

      // Aplica formatação em tempo real para CEP
      zipInput.addEventListener("input", function (e) {
        // Remove erro quando usuário digita
        showInputError(e.target, false);

        const cursorPosition = e.target.selectionStart;
        const formattedValue = formatCEP(e.target.value);
        e.target.value = formattedValue;

        // Ajusta a posição do cursor
        if (formattedValue.length === 6 && cursorPosition === 5) {
          e.target.setSelectionRange(6, 6);
        }
      });

      // Busca o estado quando o CEP está completo (quando sai do campo)
      zipInput.addEventListener("blur", async function (e) {
        const cep = e.target.value;
        if (cep.length === 9) {
          // CEP completo com máscara - processa tudo automaticamente
          await processarCEPCompleto(calculator, cep);
        }
      });

      // Também busca quando o usuário para de digitar por 1 segundo
      let timeout;
      zipInput.addEventListener("input", function (e) {
        clearTimeout(timeout);
        timeout = setTimeout(async () => {
          const cep = e.target.value;
          if (cep.length === 9) {
            // CEP completo com máscara - faz tudo automaticamente
            await processarCEPCompleto(calculator, cep);
          }
        }, 1000);
      });

      // Função completa para processar CEP automaticamente
      async function processarCEPCompleto(calculator, cep) {
        const button = calculator.querySelector('button[type="button"]');
        const errors = calculator.querySelector(".js-errors");
        const rates = calculator.querySelector(".js-rates");

        try {
          // Mostra loading
          setButtonLoading(true);
          button.textContent = "Buscando localização...";

          // Esconde resultados anteriores
          if (errors) errors.hidden = true;
          if (rates) rates.hidden = true;

          // 1. Busca dados do CEP
          const dadosCEP = await buscarCEP(cep);
          if (!dadosCEP) {
            throw new Error("CEP não encontrado");
          }

          // 2. Seleciona o estado automaticamente
          button.textContent = "Selecionando estado...";
          await new Promise((resolve) => {
            setTimeout(() => {
              selecionarEstado(dadosCEP.uf);
              resolve();
            }, 300);
          });

          // 3. Calcula frete automaticamente
          button.textContent = "Calculando frete...";

          // Chama a função de calcular frete que está definida no final do arquivo
          await calcularFreteCompleto(
            calculator,
            cep,
            "Brazil",
            provinceSelect.value
          );
        } catch (error) {
          console.log("Erro ao processar CEP:", error);
          setButtonLoading(false);

          // Mostra erro visual no input
          zipInput.style.borderColor = "#ff4444";
          setTimeout(() => {
            zipInput.style.borderColor = "";
          }, 3000);
        }
      }

      // Se já houver um valor, formata
      if (zipInput.value) {
        zipInput.value = formatCEP(zipInput.value);
      }
    }
  });

  // Função global para calcular frete (será chamada de dentro e fora do forEach)
  async function calcularFreteCompleto(calculator, zip, country, province) {
    const errors = calculator.querySelector(".js-errors");
    const rates = calculator.querySelector(".js-rates");
    const button = calculator.querySelector("button");

    try {
      const params = `shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`;

      // Tenta diferentes URLs caso não tenha theme.routes definido
      const possibleUrls = [
        `${
          window.theme?.routes?.cart || "/cart"
        }/shipping_rates.json?${params}`,
        `/cart/shipping_rates.json?${params}`,
      ];

      let response;
      let data;

      for (const url of possibleUrls) {
        try {
          response = await fetch(url);
          data = await response.json();
          break;
        } catch (urlError) {
          console.log(`Tentativa de URL falhou: ${url}`, urlError);
          continue;
        }
      }

      if (response && response.ok) {
        showRatesResult(calculator, data);
      } else {
        showErrorsResult(
          calculator,
          data || { error: "Erro ao calcular frete" }
        );
      }
    } catch (error) {
      console.log("Erro na requisição:", error);
      showErrorsResult(calculator, {
        error: "Erro ao calcular frete. Tente novamente.",
      });
    } finally {
      button.classList.remove("is-loading");
      button.disabled = false;
      button.textContent = "Calcular";
    }
  }

  // Intercepta o clique para buscar estado e calcular frete em uma única ação
  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest('shipping-calculator button[type="button"]')) {
        const calculator = e.target.closest("shipping-calculator");
        const zipInput = calculator.querySelector(".js-zip-input");
        const provinceSelect = calculator.querySelector(".js-province-select");
        const button = e.target.closest('button[type="button"]');

        if (zipInput && provinceSelect && button) {
          // Verifica se o CEP está no formato correto
          const cepPattern = /^[0-9]{5}-[0-9]{3}$/;
          if (!cepPattern.test(zipInput.value)) {
            // Em vez de alert, mostra erro visual
            zipInput.style.borderColor = "#ff4444";
            zipInput.focus();

            // Remove o erro após 3 segundos
            setTimeout(() => {
              zipInput.style.borderColor = "";
            }, 3000);

            e.preventDefault();
            return false;
          }

          // Se não tem estado selecionado, busca automaticamente primeiro
          if (!provinceSelect.value || provinceSelect.selectedIndex === 0) {
            e.preventDefault(); // Para o evento original
            e.stopImmediatePropagation(); // Para todos os outros handlers

            // Mostra loading
            button.disabled = true;
            button.textContent = "Calculando frete...";
            button.classList.add("is-loading");

            // Esconde resultados anteriores
            const errors = calculator.querySelector(".js-errors");
            const rates = calculator.querySelector(".js-rates");
            if (errors) errors.hidden = true;
            if (rates) rates.hidden = true;

            // Busca o CEP automaticamente
            const cepLimpo = zipInput.value.replace(/\D/g, "");

            fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`)
              .then((response) => response.json())
              .then((data) => {
                if (!data.erro) {
                  // Mapeia UF para nome do estado
                  const estadosBrasil = {
                    AC: "Acre",
                    AL: "Alagoas",
                    AP: "Amapá",
                    AM: "Amazonas",
                    BA: "Bahia",
                    CE: "Ceará",
                    DF: "Distrito Federal",
                    ES: "Espírito Santo",
                    GO: "Goiás",
                    MA: "Maranhão",
                    MT: "Mato Grosso",
                    MS: "Mato Grosso do Sul",
                    MG: "Minas Gerais",
                    PA: "Pará",
                    PB: "Paraíba",
                    PR: "Paraná",
                    PE: "Pernambuco",
                    PI: "Piauí",
                    RJ: "Rio de Janeiro",
                    RN: "Rio Grande do Norte",
                    RS: "Rio Grande do Sul",
                    RO: "Rondônia",
                    RR: "Roraima",
                    SC: "Santa Catarina",
                    SP: "São Paulo",
                    SE: "Sergipe",
                    TO: "Tocantins",
                  };

                  const nomeEstado = estadosBrasil[data.uf];
                  if (nomeEstado) {
                    // Seleciona o estado
                    const options = provinceSelect.options;
                    for (let i = 0; i < options.length; i++) {
                      if (
                        options[i].text === nomeEstado ||
                        options[i].value === nomeEstado
                      ) {
                        provinceSelect.selectedIndex = i;
                        break;
                      }
                    }

                    // Agora busca as taxas de frete diretamente
                    setTimeout(() => {
                      calcularFreteCompleto(
                        calculator,
                        zipInput.value,
                        "Brazil",
                        provinceSelect.value
                      );
                    }, 200);

                    return;
                  }
                }

                // Se chegou aqui, erro na busca do CEP
                button.disabled = false;
                button.textContent = "Calcular";
                button.classList.remove("is-loading");
                zipInput.style.borderColor = "#ff4444";
                zipInput.focus();

                setTimeout(() => {
                  zipInput.style.borderColor = "";
                }, 3000);
              })
              .catch((error) => {
                console.log("Erro ao buscar CEP:", error);
                button.disabled = false;
                button.textContent = "Calcular";
                button.classList.remove("is-loading");
                zipInput.style.borderColor = "#ff4444";
                zipInput.focus();

                setTimeout(() => {
                  zipInput.style.borderColor = "";
                }, 3000);
              });

            return false;
          }

          // Se já tem estado selecionado, deixa o Shopify processar normalmente
          // Não intercepta o evento
        }
      }
    },
    true
  ); // Usar capture phase para interceptar antes do Shopify

  // Função para mostrar resultados
  function showRatesResult(calculator, data) {
    const rates = calculator.querySelector(".js-rates");
    const headingEl = rates.querySelector(".js-rates-heading");
    const textEl = rates.querySelector(".js-rates-text");
    textEl.innerHTML = "";

    if (data.shipping_rates && data.shipping_rates.length) {
      let ratesHTML = "";
      data.shipping_rates.forEach((rate) => {
        // Formata o preço - tenta usar formato do tema ou fallback simples
        let formattedRate = rate.price;
        if (window.theme?.settings?.moneyWithCurrencyFormat) {
          formattedRate = window.theme.settings.moneyWithCurrencyFormat.replace(
            /\{\{\s*(\w+)\s*\}\}/g,
            rate.price
          );
        } else {
          // Fallback: assume que price já vem formatado ou em centavos
          const priceInReais =
            typeof rate.price === "string"
              ? rate.price
              : `R$ ${(rate.price / 100).toFixed(2).replace(".", ",")}`;
          formattedRate = priceInReais;
        }

        ratesHTML += `<li>${rate.name}: ${formattedRate}</li>`;
      });

      headingEl.hidden = false;
      headingEl.textContent =
        data.shipping_rates.length === 1
          ? "Opção de entrega:"
          : "Opções de entrega:";
      textEl.innerHTML = `<ul class="styled-list">${ratesHTML}</ul>`;
    } else {
      headingEl.hidden = true;
      textEl.innerHTML = "Nenhuma opção de entrega disponível para este CEP.";
    }

    rates.hidden = false;
  }

  // Função para mostrar erros
  function showErrorsResult(calculator, data) {
    const errors = calculator.querySelector(".js-errors");
    let errorsHTML = "";

    if (typeof data === "object" && data !== null) {
      Object.keys(data).forEach((key) => {
        errorsHTML += `<li>${data[key]}</li>`;
      });
    } else {
      errorsHTML = `<li>Erro ao calcular frete. Verifique o CEP e tente novamente.</li>`;
    }

    errors.querySelector(
      ".js-errors-text"
    ).innerHTML = `<ul class="styled-list">${errorsHTML}</ul>`;
    errors.hidden = false;
  }
});
